import {Component, OnDestroy, OnInit} from '@angular/core';
import {debounceTime, Subject, takeUntil} from "rxjs";
import {DropdownOption} from "../../../../../../models/dropdown-option.model";
import * as Validation
  from "../../../../../shared/constants/validation.constants";
import {FormControl, FormGroup} from "@angular/forms";
import {Store} from "@ngrx/store";
import * as fromRoot from "../../../../../../state/app.state";
import {Router} from "@angular/router";
import {CommonService} from "../../../../../shared/services/common.service";
import {
  FetchClinicFilterRequest,
  FetchGroupTypeFilterRequest,
  FetchStatusFilterRequest
} from "../../../core/clients-list.actions";
import {
  clinicFilter,
  groupTypeFilter,
  statusFilter
} from "../../../core/clients-list.selectors";
import {ClientListService} from "../../../services/client-list.service";
import {Filter} from "../../../../../../models/filter";
import {roles} from "../../../../../shared/constants/common.constants";
import {enableDebugTools} from "@angular/platform-browser";

@Component({
  selector: 'app-group-information-filter',
  templateUrl: './group-information-filter.component.html',
  styleUrls: ['./group-information-filter.component.css']
})
export class GroupInformationFilterComponent implements OnInit, OnDestroy {

  loading: boolean = false;
  statusFilterList: DropdownOption[] = [];
  groupTypeFilterList: DropdownOption[] = [];
  errorMessages: any = {};
  validation = Validation;
  clientOptions: Filter = {
    list: [],
    total: 0,
    pageNumber: 1,
    limit: 10,
    hasNext: false,
    hasPrev: false,
    loading: false
  };
  errorMessageMap = {
    'clientId': {
      required: 'This field is required.'
    },
    'status': {
      required: 'This field is required.'
    },
    'type': {
      required: 'This field is required.'
    },
    'searchText': {
      required: 'This field is required.'
    }
  }
  form = new FormGroup({
    clientId: new FormControl({value: null, disabled: false}),
    searchClient: new FormControl({value: '', disabled: false}),
    status: new FormControl({value: null, disabled: false}),
    type: new FormControl({value: null, disabled: false}),
    searchText: new FormControl({value: null, disabled: false}),
  })
  protected readonly roles = roles;
  protected readonly enableDebugTools = enableDebugTools;
  private readonly onDestroy: Subject<any> = new Subject<any>();

  constructor(
    private store: Store<fromRoot.State>,
    private router: Router,
    private commonService: CommonService,
    private clientListService: ClientListService
  ) {
    this.fetchClientsFilterList();
    this.store.dispatch(FetchStatusFilterRequest());
    this.store.dispatch(FetchGroupTypeFilterRequest());
  }

  ngOnInit() {
    this.store.select(clinicFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.clientOptions.list.push(...data?.list || []);
        this.clientOptions.hasNext = data?.hasNext
        this.clientOptions.loading = data?.loading;
      });

    this.store.select(statusFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.loading = data.loading;
        this.statusFilterList = data.list;
      });

    this.store.select(groupTypeFilter)
      .pipe(takeUntil(this.onDestroy))
      .subscribe((data) => {
        this.loading = data.loading;
        this.groupTypeFilterList = data.list;
      });

    this.form.controls.searchClient.valueChanges
      .pipe(debounceTime(1000), takeUntil(this.onDestroy))
      .subscribe(data => {
        this.clientOptions.pageNumber = 1;
        this.clientOptions.list = [];
        this.fetchClientsFilterList();
      });
  }

  fetchClientsFilterList() {
    const payload: any = {
      pageNumber: this.clientOptions?.pageNumber,
      limit: this.clientOptions?.limit,
      shouldInclude: this.form.value.clientId,
    };
    if (this.form.controls?.searchClient?.value.trim()) {
      payload.search = this.form.controls.searchClient.value;
    }
    this.store.dispatch(FetchClinicFilterRequest({payload}));
  }

  clientsOnNextPage() {
    this.clientOptions.pageNumber = this.clientOptions.pageNumber + 1
    this.fetchClientsFilterList();
  }

  apply() {
    // ERROR CHECK IN THE FORM//
    if (this.form.invalid) {
      this.checkForErrors();
      return;
    }
    if (!this.form.dirty) { // check is there any change
      return;
    }
    // changes just applied, so marking the form as un-dirty to avoid applying same filters again without changing anything
    this.form.markAsPristine();

    // EXTRACT VALUE FROM FORM//
    const {clientId, status, type, searchText} = this.form.getRawValue();
    // PAYLOAD CREATION//
    const payload = {
      clientId,
      type,
      status,
      searchText
    };

    // remove unselected filter control with value null
    for (const payloadKey in payload) {
      if (!payload[payloadKey]) {
        delete payload[payloadKey]
      }
    }

    this.clientListService.onGroupFilterChange.next(payload);

  }

  checkForErrors(currentField ?: string) {
    this.errorMessages = {
      ...this.errorMessages,
      ...(this.commonService.checkFormValidation(this.form, this.errorMessageMap, currentField))
    };
  }

  ngOnDestroy() {
    this.onDestroy.next(null);
    this.onDestroy.complete();
  }
}
